import { Cols } from "../shared/Consts";
import PortUtils from "../portlibs/PortUtils";
import usePortfolio from "../hooks/PortfolioProvider";
import Portfolio from "../models/Portfolio";
import { usePath } from "../libs/path/PathProvider";
import HoldingTable from "../components/HoldingTable";
import useDateRangeFilter from "../portlibs/DateRangeFilterProvider";

export default function HoldingPage(){
    const {query} = usePath()
    const {account,currency,filter} = PortUtils.getFilter(query);
    const {portfolio} = usePortfolio()
    const {end} = useDateRangeFilter()

    const cols = [Cols.name, Cols.quantity, Cols.averagePrice, Cols.currentPrice, Cols.holdingCost, Cols.holdingValue, Cols.ugain, Cols.holdingPercent];
    let rows = portfolio.filter(currency, filter, account, true).filter(holding => !PortUtils.isZero(holding.quantity))
    if (!PortUtils.dateEq(end.toDate(), new Date())) rows = PortUtils.trimHoldings(rows, end.toDate().getTime())
    const total = Portfolio.buildTotal(currency, rows, portfolio.getDeposits(account, currency));
    return <HoldingTable tableName="holding" cols={cols} rows={rows} footer={total}/>
}